import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=3a67477b&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=ts&"
export * from "./InfoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=3a67477b&scoped=true&lang=scss&"
import style1 from "./InfoPopup.vue?vue&type=style&index=1&id=3a67477b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67477b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon,VSpacer})
